module.exports = __webpack_public_path__ + "img/plus_btn.bb3080b3.png";